// src/auth.js
import {
  GoogleAuthProvider,
  signInWithPopup,
  signOut,
  deleteUser,
} from "firebase/auth";
import { auth } from "./Firebase";

// ---- Google sign-in ----
const googleProvider = new GoogleAuthProvider(); // [web:21]

export const signInWithGoogle = async () => {
  try {
    const res = await signInWithPopup(auth, googleProvider); // [web:21]
    return res.user; // [web:21]
  } catch (e) {
    console.error("Google sign-in failed:", e.code, e.message); // [web:21]
    throw e; // [web:21]
  }
};

// ---- Session management ----
export const doSignOut = () => signOut(auth); // [web:23]

// Deleting the current user may require a recent login. [web:32]
export const doDeleteAccount = async () => {
  const user = auth.currentUser; // [web:32]
  if (!user) return; // [web:32]
  try {
    await deleteUser(user); // [web:32]
  } catch (e) {
    if (e?.code === "auth/requires-recent-login") {
      alert("For security, please sign in again and retry account deletion."); // [web:32]
    } else {
      console.error("Delete account failed:", e.code, e.message); // [web:32]
      throw e; // [web:32]
    }
  }
};
